// extracted by mini-css-extract-plugin
export default {"balloonLayout":"balloonLayout-module__balloonLayout--AFdkt","balloonTail":"balloonLayout-module__balloonTail--ti1WZ"};